import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface DestroyResolution886ReportParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useDestroyResolution886Report = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: DestroyResolution886ReportParams) => Service.destroy(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_RESOLUTION_886]);
			message.success(I18n.get('Report deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Ops... something happened!'));
		}
	});
};
